import * as React from "react";

const IconPaginationSmallLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12">
            <polygon
                fill="currentColor"
                points=".003 6.002 .525 5.476 5.434 .526 5.956 0 6.997 1.052 6.475 1.578 2.085 6.002 6.478 10.425 7 10.951 5.956 12 5.434 11.474 .522 6.527 0 6.002"
            />
        </svg>
    );
};

export default React.memo(IconPaginationSmallLeft);
